// listo revamp

function accordionsInit() {
  const accordions = document.querySelectorAll('[data-accordion]');

  if (accordions == null) {
    return;
  }

  accordions.forEach(accordion => {
    const accordionToggle = accordion.querySelector('[data-accordion-title]');
    const accordionToggleIcon = accordion.querySelector('[data-accordion-title-icon]');
    const accordionContent = accordion.querySelector('[data-accordion-content]');
    accordionToggle.addEventListener('click', (event) => {
      event.preventDefault();

      accordion.classList.toggle('is-active');
      if (accordion.classList.contains('is-active')) {
        accordionContent.style.maxHeight = `${accordionContent.scrollHeight}px`;
        accordionToggleIcon.textContent = '-';
        setTimeout(() => {
          accordionContent.removeAttribute('style');
          accordionContent.classList.add('is-open');
        }, 500);
      } else {
        accordionContent.removeAttribute('style');
        accordionContent.classList.remove('is-open');
        accordionToggleIcon.textContent = '+';
      }
    });
  });
}


// product form

window.product = window.product || {};

const product = window.product;
const stockProductDetails = document.querySelectorAll('[data-stock-product-details]');
const notifyForm = document.querySelector('[data-out-of-stock]');
const notifyVariantInput = document.querySelector('[data-notify-variant]');

product.form = (options) => {
  const moneyFormat = theme.moneyFormat;
  const variant = options.variant;
  const currentProduct = document.getElementById(options.selector.domIdPrefix).closest('[data-product]');
  const productImageWrappers = currentProduct.querySelectorAll('[data-product-image-wrapper]');
  const productSubmit = currentProduct.querySelector('[data-product-submit]');
  const productSubmitText = currentProduct.querySelector('[data-product-submit-text]');
  const productPriceElements = currentProduct.querySelectorAll('[data-product-price]');
  const comparePrice = currentProduct.querySelector('[data-product-compare-price]');

  if (stockProductDetails.length && variant) {
    stockProductDetails.forEach((details) => {
      details.classList.add('hide');
    });
    const current = document.querySelector(`[data-stock-product-details="${variant.id}"]`);
    if (current) {
      current.classList.remove('hide');
    }
  }

  if (variant) {
    if (productImageWrappers.length && variant.featured_image) {
      productImageWrappers.forEach((productImageWrapper) => {
        const wrapperImageId = parseFloat(productImageWrapper.getAttribute('data-image-id'));

        if (wrapperImageId === variant.featured_image.id) {
          productImageWrapper.classList.remove('hide');
        } else {
          productImageWrapper.classList.add('hide');
        }
      });
    }

    if (variant.available) {
      productSubmitText.innerHTML = theme.strings.addToCart;

      if (notifyForm) {
        productSubmit.classList.remove('hide');
        notifyForm.classList.add('hide');
      }
    } else {
      productSubmitText.innerHTML = theme.strings.soldOut;

      if (notifyForm) {
        productSubmit.classList.add('hide');
        notifyForm.classList.remove('hide');
        notifyVariantInput.value = variant.id;
      }
    }

    productPriceElements.forEach((productPriceElement) => {
      productPriceElement.innerHTML = Shopify.formatMoney(variant.price, moneyFormat);
    });

    if (comparePrice) {
      if (variant.compare_at_price > variant.price) {
        comparePrice.innerHTML = Shopify.formatMoney(variant.compare_at_price, moneyFormat);
        comparePrice.classList.remove('hide');
      } else {
        comparePrice.classList.add('hide');
      }
    }

  } else {
    productSubmit.classList.add('disabled');
    productSubmit.setAttribute('disabled', true);
    productSubmitText.innerHTML = theme.strings.unavailable;
  }
};


// product custom gallery
// import {trapFocus, removeTrapFocus} from '@shopify/theme-a11y';
function customProductGallery() {
  const siteBody = document.querySelector('[data-site-body]');
  const customizerButton = document.querySelector('[data-mobile-product-customizer-toggle]');
  const galleryWraps = document.querySelectorAll('[data-product-custom-gallery-wrap]');
  if (!galleryWraps) { return; }

  galleryWraps.forEach(galleryWrap => {
    const gallery = galleryWrap.querySelector('[data-product-custom-gallery]');
    if (!gallery) { return; }

    console.log(gallery);

    const content = galleryWrap.querySelector('[data-product-custom-gallery-content]');
    const galleryImageWrap = galleryWrap.querySelector('[data-product-custom-gallery-images]');
    const galleryImages = galleryImageWrap.querySelectorAll('[data-product-custom-image]');
    const galleryThumbsWrap = galleryWrap.querySelector('[data-product-custom-gallery-thumbs]');
    const galleryThumbs = galleryThumbsWrap.querySelectorAll('[data-product-custom-thumb]');
    const galleryActivateThumbs = galleryWrap.querySelector('[data-product-custom-thumbs]');
    const mobileGalleryOpenButton = galleryWrap.querySelector('[data-product-custom-gallery-mobile-toggle]');
    const closeButton = galleryWrap.querySelector('[data-product-custom-gallery-close]');
    const ctaButton = galleryWrap.querySelector('[data-product-custom-gallery-cta]');
    let lastScrollPos = null;
    let galleryControls = null;
    const galleryControlsWrapper = galleryWrap.querySelector('[data-product-custom-gallery-controls]');
    const galleryMore = galleryWrap.querySelector('[data-product-custom-gallery-more]');

    if (galleryControlsWrapper) {
      galleryControls = galleryControlsWrapper.querySelectorAll('[data-product-custom-gallery-control]');
    }

    if (!galleryImages || !galleryThumbs) { return; }

    // Clone gallery thumbs into content
    const galleryThumbsClone = galleryThumbsWrap.cloneNode(true);
    galleryActivateThumbs.appendChild(galleryThumbsClone);
    const activateThumbs = galleryActivateThumbs.querySelectorAll('[data-product-custom-thumb]');

    activateThumbs.forEach(activateThumb => {
      activateThumb.addEventListener('click', handleActivateThumbClick);
    });

    function handleActivateThumbClick(event) {
      const thumb = event.currentTarget;
      const matchingGalleryThumb = galleryThumbsWrap.querySelector(`[data-thumb-index="${thumb.dataset.thumbIndex}"]`);
      content.classList.add('hidden');
      gallery.classList.remove('hide');
      matchingGalleryThumb.click();
      setTimeout(() => {
        document.addEventListener('click', handleClickOutsideClose);
      }, 100);

      handleArrowsNavigation();
    }

    function handleArrowsNavigation() {
      document.addEventListener('keydown', handleArrowsNavigationEvent);

      if (galleryControls && galleryMore) {
        galleryControlsWrapper.classList.remove('hide');
        galleryMore.classList.add('hide');

        galleryControls.forEach((control) => {
          control.addEventListener('click', handleControls);
        });
      }
    }

    function handleControls(event) {
      handleArrowsNavigationEvent({key: event.target.getAttribute('data-product-custom-gallery-control')});
    }

    function handleArrowsNavigationEvent(event) {
      let index = 0;
      galleryImages.forEach((image) => {
        if (!image.classList.contains('hide')) {
          index = parseInt(image.getAttribute('data-image-index'), 10);
        }
      });

      /* eslint-disable indent */
      switch (event.key) {
        case 'ArrowLeft':
          index -= 2;
          hideImages();
          if (index < 0) {
            galleryImages[galleryImages.length - 1].classList.remove('hide');
          } else {
            galleryImages[index].classList.remove('hide');
          }
          break;
        case 'ArrowRight':
          hideImages();
          if (index >= galleryImages.length) {
            galleryImages[0].classList.remove('hide');
          } else {
            galleryImages[index].classList.remove('hide');
          }
          break;
      }
      /* eslint-enable indent */

      function hideImages() {
        galleryImages.forEach((image) => {
          image.classList.add('hide');
        });
      }
    }

    function removeArrowsNavigation() {
      document.removeEventListener('keydown', handleArrowsNavigationEvent);
    }

    if (mobileGalleryOpenButton) {
      mobileGalleryOpenButton.addEventListener('click', handleMobileGalleryOpen);
    }

    function handleMobileGalleryOpen() {
      lastScrollPos = window.scrollY;
      content.classList.add('hidden');
      gallery.classList.remove('hide');
      galleryWrap.classList.add('mobile-open');
      galleryThumbs[0].click();
      trapFocus(gallery);
      handleArrowsNavigation();

      if (window.innerWidth < 750 && mobileGalleryOpenButton.getAttribute('data-product-custom-gallery-mobile-toggle') === 'quality') {
        siteBody.classList.add('drawer-active', 'popup-open');
      }
    }

    function handleClickOutsideClose(event) {
      const isOnGallery = event.path.find(element => typeof element.classList !== 'undefined' && element.classList.contains('product-custom-gallery'));
      if (!isOnGallery) {
        closePopup();
      }
    }

    galleryThumbs.forEach(galleryThumb => {
      galleryThumb.addEventListener('click', handleGalleryThumbClick);
    });

    function handleGalleryThumbClick(event) {
      const thumb = event.currentTarget;
      const matchingImage = galleryImageWrap.querySelector(`[data-image-index="${thumb.dataset.thumbIndex}"]`);

      galleryThumbs.forEach(galleryThumb => galleryThumb.classList.remove('active'));
      thumb.classList.add('active');
      galleryImages.forEach(galleryImage => galleryImage.classList.add('hide'));
      matchingImage.classList.remove('hide');
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => {
        closePopup();
      });
    }

    if (ctaButton) {
      ctaButton.addEventListener('click', () => {
        closePopup();
        if (customizerButton) customizerButton.click();
      });
    }

    function closePopup() {
      content.classList.remove('hidden');
      gallery.classList.add('hide');
      galleryWrap.classList.remove('mobile-open');
      removeTrapFocus(gallery);

      if (window.innerWidth < 750) {
        siteBody.classList.remove('drawer-active', 'popup-open');
      }

      document.removeEventListener('click', handleClickOutsideClose);
      removeArrowsNavigation();
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  customProductGallery();
});

document.addEventListener('shopify:section:load', () => {
  customProductGallery();
});



// prod description gallery

function productDescriptionGalleryInit() {
  const productDescriptionGallery = document.querySelector('[data-product-description-gallery-images]');
  const productDescriptionThumbs = document.querySelector('[data-product-description-gallery-thumbs]');

  if (!productDescriptionGallery) { return; }

  const thumbsSwiper = new Swiper(productDescriptionThumbs, {
    spaceBetween: 12,
    slidesPerView: 4,
    preventClicks: false,
    preventClicksPropagation: false,
    noSwiping: true,
    threshold: 1000,
    direction: 'vertical',
    breakpoints: {
      1100: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });

  new Swiper(productDescriptionGallery, {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      dynamicMainBullets: 6
    },
    navigation: {
      nextEl: '.product-description-gallery .swiper-button-next',
      prevEl: '.product-description-gallery .swiper-button-prev',
    },
    thumbs: {
      swiper: thumbsSwiper,
    },
  });

  thumbsSwiper.update();
}

document.addEventListener('DOMContentLoaded', () => {
  productDescriptionGalleryInit();
});


// custom breadcrumbs 

function setupDropdown(dropdown) {
  if (dropdown === null) { return; }

  const dropdownToggle = dropdown.querySelector('[data-dropdown-toggle]');
  const dropdownList = dropdown.querySelector('[data-dropdown-list]');
  const dropdownOptions = dropdown.querySelectorAll('[data-dropdown-option]');
  const dropdownOverlay = dropdown.querySelector('[data-dropdown-overlay]');

  dropdownToggle.addEventListener('keydown', handleDropdownToggle);
  dropdownToggle.addEventListener('click', handleDropdownToggle);

  dropdownList.addEventListener('keydown', handleKeyNavigation);

  dropdownOptions.forEach(option => {
    option.addEventListener('click', selectDropdownItem);
    option.addEventListener('keydown', selectDropdownItem);
  });

  dropdownOverlay.addEventListener('click', () => closeDropdown(dropdown));
}

// Toggle Dropdown
function handleDropdownToggle(event) {
  event.preventDefault();
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  if (event.code && (event.code !== 'Space' || event.code !== 'Enter')) { return; }

  const dropdown = event.target.closest('[data-dropdown]');
  const dropdownList = dropdown.querySelector('[data-dropdown-list]');

  if (dropdown.classList.contains('is-active')) {
    closeDropdown(dropdown);
  } else {
    // close open dropdowns
    dropdowns.forEach(dropdown => closeDropdown(dropdown));

    // open this one
    dropdown.classList.add('is-active');
    dropdown.setAttribute('aria-expanded', 'true');
    dropdownList.removeAttribute('hidden');

    setTimeout(() => {
      dropdownList.focus();
    }, 500);
  }
}

function closeDropdown(dropdown) {
  const dropdownList = dropdown.querySelector('[data-dropdown-list]');
  dropdown.classList.remove('is-active');
  dropdown.setAttribute('aria-expanded', 'false');
  dropdownList.setAttribute('hidden', '');
}

function handleKeyNavigation(event) {
  const key = event.keyCode;
  const dropdown = event.currentTarget.closest('[data-dropdown]');
  const options = dropdown.querySelectorAll('[data-dropdown-option]');
  const current = [...options].indexOf(dropdown.querySelector('[aria-activedescendant="true"]'));

  /* eslint-disable indent */
  let index = 0;
  switch (key) {
    case 13: // ENTER
      event.preventDefault();
      selectDropdownItem(event);
      break;
    case 32: // SPACE
      event.preventDefault();
      selectDropdownItem(event);
      break;
    case 27: // ESC
      event.preventDefault();
      closeDropdown(dropdown);
      break;
    case 35: // END
      event.preventDefault();
      index = options.length - 1;
      setActiveDescendant(index, current);
      break;
    case 36: // HOME
      event.preventDefault();
      index = options[0];
      setActiveDescendant(index, current);
      break;
    case 38: // UP
      event.preventDefault();
      index = current > 0 ? current - 1 : 0;
      setActiveDescendant(index, current);
      break;
    case 40: // DOWN
      event.preventDefault();
      index = current < options.length - 1 ? current + 1 : options.length - 1;
      setActiveDescendant(index, current);
      break;
  }
}

function selectDropdownItem(event) {
  const option = (event.code && event.code === 'Enter' || event.code === 'Space') ? event.target.querySelector('[aria-activedescendant]') : event.target;
  const optionText = option.querySelector('[data-dropdown-option-text]');
  const dropdown = option.closest('[data-dropdown]');
  const toggleText = dropdown.querySelector('[data-dropdown-toggle-text]');
  const options = dropdown.querySelectorAll('[data-dropdown-option]');
  const input = dropdown.querySelector('[data-dropdown-input]');
  const parentForm = input.closest('form');
  options.forEach(opt => opt.removeAttribute('aria-selected'));
  option.setAttribute('aria-selected', 'true');
  option.removeAttribute('aria-activedescendant');

  let buttonContent = '';
  if (optionText === null) {
    buttonContent = option.innerText;
  } else {
    buttonContent = optionText.innerHTML;
  }
  if (dropdown.dataset.preLabel) {
    buttonContent = `<strong>${dropdown.dataset.preLabel}:</strong> ${buttonContent}`;
  }

  toggleText.innerHTML = buttonContent;

  const optionValue = input.type === 'number' ? Number(option.dataset.value) : option.dataset.value;
  input.value = optionValue;

  const changeEvent = new Event('change');
  input.dispatchEvent(changeEvent);

  if (parentForm) {
    parentForm.dispatchEvent(changeEvent);
  }

  closeDropdown(dropdown);
}

function setActiveDescendant(index, current) {
  const dropdown = event.currentTarget;
  const options = dropdown.querySelectorAll('[data-dropdown-option]');

  let nextElement = options[index];
  if (typeof nextElement === 'undefined') { return; }

  if (nextElement.hasAttribute('aria-selected') && index > current) {
    nextElement = options[index + 1];
  } else if (nextElement.hasAttribute('aria-selected') && index < current) {
    nextElement = options[index - 1];
  }
  if (nextElement == null) {
    return;
  }

  options.forEach(option => option.removeAttribute('aria-activedescendant'));
  nextElement.setAttribute('aria-activedescendant', 'true');
  setTimeout(() => {
    nextElement.focus();
  }, 10);
}


function breadcrumbsCustom() {
  const dropdowns = document.querySelectorAll('[data-dropdown]');

  dropdowns.forEach(dropdown => {
    setupDropdown(dropdown);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  breadcrumbsCustom();
});


// custom thumbnails 

function productThumbnails() {
  const productThumbnailImages = document.querySelectorAll('[data-product-thumbnail]');

  if (!productThumbnailImages.length) { return; }

  productThumbnailImages.forEach((productThumbnailImage) => {
    productThumbnailImage.addEventListener('click', () => updateImage(productThumbnailImage));
    productThumbnailImage.addEventListener('keydown', () => updateImage(productThumbnailImage));
  });

  function updateImage(productThumbnailImage) {
    if (event.type === 'keydown' && event.keyCode !== 13) { return; }

    productThumbnailImages.forEach(productThumb => productThumb.classList.remove('active'));
    productThumbnailImage.classList.add('active');

    const productImageWrappers = productThumbnailImage.closest('[data-product]').querySelectorAll('[data-product-image-wrapper]');
    const thumbnailImageId = productThumbnailImage.getAttribute('data-image-id');

    productImageWrappers.forEach((productImageWrapper) => {
      const wrapperImageId = productImageWrapper.getAttribute('data-image-id');

      if (wrapperImageId === thumbnailImageId) {
        productImageWrapper.classList.remove('hide');
      } else {
        productImageWrapper.classList.add('hide');
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  productThumbnails();
});


// swatches 

function handleSwatches() {
  const productJson = document.querySelector('[data-product-json]');

  if (productJson == null) { return; }

  const productObj = JSON.parse(productJson.innerHTML);
  const product = productObj;

  if (product == null) { return; }

  const swatchGroups = document.querySelectorAll('[data-swatch-group]');
  const swatchElements = document.querySelectorAll('[data-swatch-element]');

  // Add listeners
  swatchElements.forEach(swatch => {
    const swatchInput = swatch.querySelector('[data-swatch-input]');
    const swatchLabel = swatch.querySelector('[data-swatch-label]');

    swatchInput.addEventListener('keydown', (event) => {
      if (event.keyCode !== '13' || event.keyCode !== '32') { return; }
      event.preventDefault();
      swatch.click();
    });

    swatchInput.addEventListener('change', handleSwatchSelect);

    swatchLabel.addEventListener('click', () => {
      if (swatchInput.disabled === false) { return; }
      swatchInput.disabled = false;
      swatchInput.checked = true;
      swatchInput.dispatchEvent(new Event('change'));

      // Reset siblings
      const optionGroup = swatchInput.getAttribute('data-variant-option-index');
      const siblingInputs = document.querySelectorAll(`[data-variant-option-index=${optionGroup}]`);
      siblingInputs.forEach(siblingInput => {
        siblingInput.disabled = false;
      });
    });
  });

  function handleSwatchSelect() {
    const selectedSwatchRadios = document.querySelectorAll('[data-swatch-input]:checked');

    // Loop through groups
    swatchGroups.forEach(group => {
      const groupSwatchParent = group.querySelector('[data-swatch]');
      const groupRadios = group.querySelectorAll('[data-swatch-input]');
      const groupSwatchRadioIndex = groupSwatchParent.dataset.variantOptionIndex;
      const groupSelectedRadio = group.querySelector('[data-swatch-input]:checked');

      if (groupSelectedRadio === null) {
        const firstAvaialbleRadio = group.querySelector('[data-swatch-input]:not([disabled])');
        firstAvaialbleRadio.checked = true;
        return;
      }

      groupRadios.forEach(radio => {
        // Find matching variants for each radio based on selected options in other groups
        const radioVariants = product.variants.filter(variant => {
          const valueMatches = [];
          selectedSwatchRadios.forEach(selectedRadio => {
            const selectedRadioVariantIndex = selectedRadio.dataset.variantOptionIndex;
            if (selectedRadioVariantIndex === groupSwatchRadioIndex) { return; }
            if (selectedRadio.value === variant[selectedRadioVariantIndex]) {
              valueMatches.push(true);
            } else {
              valueMatches.push(false);
            }
          });

          const radioVariantIndex = radio.dataset.variantOptionIndex;
          if (radio.value === variant[radioVariantIndex]) {
            valueMatches.push(true);
          } else {
            valueMatches.push(false);
          }

          return !valueMatches.includes(false);
        });

        if (radioVariants.length < 1) {
          radio.disabled = true;
          radio.checked = false;
        } else {
          radio.disabled = false;
        }
      });

      // Update hidden select fields
      const optionSelector = document.querySelector(`[data-option="${groupSwatchRadioIndex}"]`);
      optionSelector.value = groupSelectedRadio.value;
      optionSelector.dispatchEvent(new Event('change'));
    });
  }

  const optionSelectors = document.querySelectorAll('[data-option]');
  optionSelectors.forEach(selector => {
    const option = document.createElement('option');
    option.value = 'null';
    option.text = 'null';
    selector.add(option);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  handleSwatches();
});

document.addEventListener('shopify:section:load', () => {
  handleSwatches();
});

// product sample

function sampleProductInit() {
  const sampleProduct = document.querySelector('[data-sample-product]');
  if (sampleProduct == null) { return; }

  const swatchInputs = document.querySelectorAll('[data-swatch-input]');
  const otherNotice = document.querySelector('[data-sample-other-notice]');

  swatchInputs.forEach(swatchInput => {
    swatchInput.addEventListener('change', (event) => {
      if (swatchInput.value === 'Other') {
        otherNotice.classList.remove('hide');
      } else {
        otherNotice.classList.add('hide');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  sampleProductInit();
});



// revamp options

// Shared variables
let currentVariant = '';
let productJSON = '';
let variantTiers = [];

let setProductJSON = function() {
  let productInfoEl = document.querySelector('[data-product-json]');
  productJSON = JSON.parse(productInfoEl.innerHTML);
};

let setVariantTiers = function() {
  let variantTierTags = productJSON.tags.filter(tag =>
    tag.includes('unit-price-sku#')
  );
  for (let i = 0; i < variantTierTags.length; i++) {
    let tag = variantTierTags[i].split('#')[1];
    let priceTiers = [];
    let variantSKU = tag.split('||')[0].trim();
    let tiers = tag.split('||')[1].split('|');
    for (let j = 0; j < tiers.length; j++) {
      let tierValues = tiers[j].split(':');
      let quantity = parseInt(tierValues[0]);
      let variantUnitPrice = parseFloat(tierValues[1]);
      priceTiers.push({ quantity: quantity, unitPrice: variantUnitPrice });
    }
    variantTiers.push({ variantSKU: variantSKU, priceTiers: priceTiers });
  }
};

let generateUniqueId = function() {
  let result = '';
  // let characters =
  //   'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  // let charactersLength = characters.length;
  // for (let i = 0; i < length; i++) {
  //   result += characters.charAt(Math.floor(Math.random() * charactersLength));
  // }
  result = `${productJSON.handle}_${Date.now()}`;
  let idInput = document.querySelector(
    '[data-custom-property="customProductId"]'
  );
  idInput.value = result;
};

let setCurrentVariant = function() {
  let checkedOptions = document.querySelectorAll(
    '[data-option-selector] :checked'
  );
  let selectedOptions = [];
  for (let i = 0; i < checkedOptions.length; i++) {
    let element = checkedOptions[i];
    let value = element.value;
    selectedOptions.push(value);
  }
  let newVariant = productJSON.variants.find(variant =>
    variant.options.every(option => selectedOptions.includes(option))
  );
  currentVariant = newVariant;
  updateQuantitySwatchPricing();
  updateColor();
  updateImage();
};

let updateColor = function() {
  if (productJSON.options.includes('Color')) {
    let colorOptionIndex = productJSON.options.indexOf('Color');
    let variantColor = currentVariant.options[colorOptionIndex];
    let colorDisplayText = document.querySelector(
      '[data-swatch-title-selected-color]'
    );
    colorDisplayText.innerHTML = variantColor;
  }
};

let updateImage = function() {
  let thumbnailAltTagQuery = '[alt="NO FEATURED IMAGE"]';
  let firstDisplayItem =
    currentVariant.featured_media ||
    currentVariant.featured_image ||
    currentVariant.image;
  if (firstDisplayItem != null) {
    thumbnailAltTagQuery = `[alt*="${firstDisplayItem.alt}"`;
  }
  let thumbnailGallery = document.querySelector(
    '[data-product-description-gallery-thumbs] .swiper-wrapper'
  );
  let thumbnail = thumbnailGallery.querySelector(thumbnailAltTagQuery);
  if (thumbnail) {
    let parent = thumbnail.parentElement;
    let thumbActive = thumbnailGallery.querySelector(
      '.swiper-slide-thumb-active'
    );
    let indexParent = Array.from(thumbnailGallery.children).indexOf(parent);
    let indexActive = Array.from(thumbnailGallery.children).indexOf(
      thumbActive
    );
    let above = indexParent > indexActive;
    while (!parent.classList.contains('swiper-slide-thumb-active')) {
      if (above) {
        document.querySelector('.swiper-button-next').click();
      } else {
        document.querySelector('.swiper-button-prev').click();
      }
    }
  }
};

let updateTotalPrice = function() {
  let newTotal;
  let unitPrice;
  let productSubtotal = document.querySelector('[data-product-subtotal]');
  let quantityInput = document.querySelector('[data-input-quantity]');
  let quantityValue = quantityInput.value;
  let variantPrice = parseFloat(currentVariant.price / 100);
  let variantTier = variantTiers.filter(
    tier => tier.variantSKU === currentVariant.sku.toString()
  )[0];
  let potentialTiers = variantTier
    ? variantTier.priceTiers.filter(tier => tier.quantity <= quantityValue)
    : [];
  if (potentialTiers.length > 0) {
    let maxTier = potentialTiers.reduce((a, b) =>
      a.quantity > b.quantity ? a : b
    );
    unitPrice = parseFloat(maxTier.unitPrice);
  } else {
    unitPrice = variantPrice;
  }
  newTotal = (quantityValue * unitPrice).toFixed(2);
  productSubtotal.textContent = '$' + newTotal;
};

let checkMaxQuantity = function() {
  let addToCartButton = document.querySelector('[data-product-submit]');
  let quantityInput = document.querySelector('[data-input-quantity]');
  let quantityMaxIndicator = document.querySelector(
    '[data-max-quantity-notice]'
  );
  let quantityValue = parseInt(quantityInput.value);
  let maxOrderQuantity = parseInt(
    quantityInput.getAttribute('data-max-order-quantity')
  );
  if (maxOrderQuantity) {
    if (quantityValue <= maxOrderQuantity) {
      addToCartButton.disabled = false;
      // quoteButtonSubmit.disabled = false;
      if (!quantityMaxIndicator.className.match(/\hide\b/)) {
        quantityMaxIndicator.className += ' hide';
      }
    } else {
      addToCartButton.disabled = true;
      // quoteButtonSubmit.disabled = true;
      if (quantityMaxIndicator.className.match(/\hide\b/)) {
        quantityMaxIndicator.className = quantityMaxIndicator.className.replace(
          /(?:^|\s)hide(?!\S)/g,
          ''
        );
      }
    }
  }
};

let checkMinQuantity = function() {
  let addToCartButton = document.querySelector('[data-product-submit]');
  let quantityInput = document.querySelector('[data-input-quantity]');
  let quantityMinIndicator = document.querySelector(
    '[data-min-quantity-notice]'
  );
  let quantityValue = parseInt(quantityInput.value);
  let minOrderQuantity = parseInt(
    quantityInput.getAttribute('data-min-order-quantity')
  );
  if (minOrderQuantity) {
    if (quantityValue >= minOrderQuantity) {
      addToCartButton.disabled = false;
      // quoteButtonSubmit.disabled = false;
      if (!quantityMinIndicator.className.match(/\hide\b/)) {
        quantityMinIndicator.className += ' hide';
      }
    } else {
      addToCartButton.disabled = true;
      // quoteButtonSubmit.disabled = true;
      if (quantityMinIndicator.className.match(/\hide\b/)) {
        quantityMinIndicator.className = quantityMinIndicator.className.replace(
          /(?:^|\s)hide(?!\S)/g,
          ''
        );
      }
    }
  }
};

let handleQuantityChange = function() {
  checkMaxQuantity();
  checkMinQuantity();
  updateTotalPrice();
};

let setQuantityValue = function(newValue) {
  let quantityInput = document.querySelector('[data-input-quantity]');
  quantityInput.value = newValue;
  handleQuantityChange();
};

let quantityInputInit = function() {
  let quantityInput = document.querySelector('[data-input-quantity]');
  quantityInput.addEventListener('input', handleQuantityChange, false);
};

let optionSelectorsInit = function() {
  let optionSelectors = document.querySelectorAll('[data-option-selector]');
  optionSelectors.forEach(selector => {
    selector.addEventListener('change', event => {
      event.preventDefault();
      setCurrentVariant();
      updateTotalPrice();
    });
  });
};

let quantitySelectorInit = function() {
  let quantityInput = document.querySelector('[data-input-quantity]');
  let quantityInputDiv = document.querySelector('[data-custom-quantity-input]');
  let quantitySelector = document.querySelector('[data-quantity-selector]');
  quantitySelector.addEventListener('change', event => {
    let selectedValue = event.target.value;
    if (selectedValue === 'Custom') {
      quantityInputDiv.className = quantityInputDiv.className.replace(
        /(?:^|\s)hide(?!\S)/g,
        ''
      );
    } else {
      if (!quantityInputDiv.className.match(/\hide\b/)) {
        quantityInputDiv.className += ' hide';
      }
      let quantityNew = parseInt(selectedValue);
      setQuantityValue(quantityNew);
    }
  });
  let startValue = parseInt(quantityInput.value);
  setQuantityValue(startValue);
};

let updateQuantitySwatchPricing = function() {
  let quantitySelector = document.querySelector('[data-quantity-selector]');
  let variantPrice = parseFloat(currentVariant.price / 100);
  let isRadio = quantitySelector.querySelector('input');
  if (isRadio) {
    let radioButtons = quantitySelector.querySelectorAll('input');
    for (let i = 0; i < radioButtons.length; i++) {
      let radioButton = radioButtons[i];
      let radioButtonValue = radioButton.value;
      if (radioButtonValue !== 'Custom') {
        let unitPrice;
        let variantTier = variantTiers.filter(
          tier => tier.variantSKU === currentVariant.sku.toString()
        )[0];
        let potentialTiers = variantTier
          ? variantTier.priceTiers.filter(
              tier => tier.quantity <= radioButtonValue
            )
          : [];
        if (potentialTiers.length > 0) {
          let maxTier = potentialTiers.reduce((a, b) =>
            a.quantity > b.quantity ? a : b
          );
          unitPrice = parseFloat(maxTier.unitPrice);
        } else {
          unitPrice = variantPrice;
        }
        let parentElement = radioButton.parentElement;
        let pricingSpan = parentElement.querySelector('[data-label-price]');
        pricingSpan.innerHTML = '$' + unitPrice.toFixed(2) + ' ea';
      }
    }
  } else {
    for (let i = 0; i < quantitySelector.options.length; i++) {
      let option = quantitySelector.options[i];
      let optionValue = option.value;
      if (optionValue !== 'Custom') {
        let unitPrice;
        let variantTier = variantTiers.filter(
          tier => tier.variantSKU === currentVariant.sku.toString()
        )[0];
        let potentialTiers = variantTier
          ? variantTier.priceTiers.filter(tier => tier.quantity <= optionValue)
          : [];
        if (potentialTiers.length > 0) {
          let maxTier = potentialTiers.reduce((a, b) =>
            a.quantity > b.quantity ? a : b
          );
          unitPrice = parseFloat(maxTier.unitPrice);
        } else {
          unitPrice = variantPrice;
        }
        option.text = optionValue + ' - $' + unitPrice.toFixed(2) + ' ea';
      }
    }
  }
};

let handleAddToCart = function() {
  let customPropertyInputs = document.querySelectorAll(
    'input[data-custom-property]'
  );
  let quantityInput = document.querySelector('[data-input-quantity]');
  let variantId = currentVariant.id;
  let quantity = parseInt(quantityInput.value);
  let customProperties = {};
  for (let i = 0; i < customPropertyInputs.length; i++) {
    let property = customPropertyInputs[i];
    if (property.value) {
      let key = `_${property.getAttribute('data-custom-property')}`;
      let value = property.value;
      customProperties[key] = value;
    }
  }

  let formData = {
    items: [
      {
        id: variantId,
        quantity: quantity,
        properties: customProperties
      }
    ]
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
    .then(response => {
      window.location.href = '/cart';
    })
    .catch(error => {
      console.error('Error:', error);
    });
};

let addToCartInit = function() {
  let addToCartButton = document.querySelector('[data-product-submit]');
  addToCartButton.addEventListener('click', event => {
    event.preventDefault();
    handleAddToCart();
  });
};

document.addEventListener('DOMContentLoaded', () => {
  setProductJSON();
  generateUniqueId();
  setVariantTiers();
  setCurrentVariant();
  optionSelectorsInit();
  quantitySelectorInit();
  quantityInputInit();
  // popupInit();
  addToCartInit();
});

// custom FAQ 

function initFaqCategories() {
  const toggles = document.querySelectorAll('[data-faq-category-toggle]');
  const groups = document.querySelectorAll('[data-faq-category]');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const targetGroup = document.querySelector(`[data-faq-category="${toggle.getAttribute('data-faq-category-toggle')}"]`);
      if (!targetGroup) { return; }

      groups.forEach(oldGroup => oldGroup.classList.add('hide'));
      targetGroup.classList.remove('hide');
      toggles.forEach(oldToggle => oldToggle.classList.remove('active'));
      toggle.classList.add('active');
    });
  });
}

function initFaqGroup(group) {
  const toggle = group.querySelector('[data-question]');
  const content = group.querySelector('[data-answer]');
  if (!toggle || !content) { return; }

  toggle.addEventListener('click', () => {
    if (toggle.hasAttribute('data-open')) {
      content.style.maxHeight = null;
      toggle.removeAttribute('data-open');
    } else {
      content.style.maxHeight = `${content.scrollHeight}px`;
      toggle.setAttribute('data-open', '');
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initFaqCategories();
  document.querySelectorAll('[data-faq-group]').forEach((group) => {
    initFaqGroup(group);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  accordionsInit();
});

